module.exports = __webpack_public_path__ + "img/cattunnel11.5db98859.jpg";